/**
 * Wrapper for es6-promise
 * @module
 */
module.exports = require('es6-promise');
